(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header        = document.querySelector('.section-header');
      this.headerWrapper = document.getElementById('ehsani-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop  = 0;
      this.preventReveal     = false;
      this.predictiveSearch  = this.querySelector('predictive-search');
      this.onScrollHandler   = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();

      // ── Keyboard accessibility for nav triggers ──
      this.initKeyboardNav();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > 50) {
        this.headerWrapper && this.headerWrapper.classList.add('scrolled');
        this.header.classList.add('scrolled-past-header');
      } else {
        this.headerWrapper && this.headerWrapper.classList.remove('scrolled');
        this.header.classList.remove('scrolled-past-header');
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((d) => d.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }

    /* ── Keyboard nav: Enter/Space opens, Escape closes, arrow keys navigate ── */
    initKeyboardNav() {
      const triggers = this.querySelectorAll('.ehsani-nav-trigger');

      triggers.forEach((trigger) => {
        const item     = trigger.closest('.ehsani-nav-item');
        const dropdown = item.querySelector('.ehsani-dropdown');
        if (!dropdown) return;

        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const isOpen = item.classList.contains('is-open');
            // Close all others
            this.querySelectorAll('.ehsani-nav-item.is-open').forEach((el) => el.classList.remove('is-open'));
            if (!isOpen) {
              item.classList.add('is-open');
              trigger.setAttribute('aria-expanded', 'true');
              const firstLink = dropdown.querySelector('a');
              if (firstLink) firstLink.focus();
            } else {
              trigger.setAttribute('aria-expanded', 'false');
            }
          }
          if (e.key === 'Escape') {
            item.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            trigger.focus();
          }
        });

        // Close on Escape from within dropdown
        dropdown.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            item.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            trigger.focus();
          }
        });
      });

      // Close open dropdowns when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.ehsani-nav-item')) {
          this.querySelectorAll('.ehsani-nav-item.is-open').forEach((el) => {
            el.classList.remove('is-open');
            const t = el.querySelector('.ehsani-nav-trigger');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
        }
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
